<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters)
        v-col(cols="10" offset="1")
          .text-xl.font-bold.text-center Change number to new user
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      v-window(v-model="step" touchless)
        v-window-item(:value="0")
          div
            div.text-md.neutral700--text Please confirm the phone number below. Click “Continue” and TAC code will be sent to the number for verification.
            div.text-sm.font-semibold.neutral500--text.mt-6 {{ $t('phone') }}
            phone-input.mt-2(v-model="phone" required)
        v-window-item(:value="1")
          div
            div.d-flex.justify-center
              v-img(:src="require('@/assets/images/phone_otp.png')" contain height="100")
            div.text-xl.font-semibold.neutral700--text.text-center.mt-6 Enter verification code
            div.text-md.neutral700--text.text-center.mt-2 We’ve sent a verification code to the customer. Enter the 4-digit verification code below to verify the phone number.
            v-row.mt-6(no-gutters justify="center")
              v-col(cols="7")
                v-otp-input.otp-input(v-model="otp" length="4" type="number")

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(color="primary" depressed :loading="isLoading" @click="postData") {{ step ? 'Confirm' : 'Continue' }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  components: { PhoneInput },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    phoneNumber: {
      default: null
    }
  },
  data () {
    return {
      isLoading: false,
      isFetching: false,
      step: 0,
      phone: null,
      otp: null,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.phone = this.phoneNumber
  },
  methods: {
    ...mapActions(['showMessage']),
    postData () {
      this.isLoading = true
      if (this.step === 0) {
        this.$axios.post(`/marketing/${this.company.slug}/redeems/request_otp`, { phone: this.phone })
          .then(() => {
            this.step = 1
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else if (this.step === 1) {
        this.$axios.post(`/marketing/${this.company.slug}/redeems/check_otp`, { phone: this.phone, otp: this.otp })
          .then(() => {
            this.$emit('updated')
            this.closeDialog()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .otp-input {
    .v-text-field fieldset, .v-text-field .v-input__control {
      border-radius: 16px;
      font-size: 30px;
      font-weight: 600;
    }
  }
}
</style>